import { render } from "./UiBreadcrumb.vue?vue&type=template&id=6a9f3f8b"
import script from "./UiBreadcrumb.vue?vue&type=script&lang=js"
export * from "./UiBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__